export const API_CODE_MESSAGE = {
    //'members_found': 'Liste des adhérents récupérée avec succès',
    'member_created': 'Adhérent créé avec succès',
    'member_not_found': 'Aucun adhérent trouvé',
    'gravity_form_updated': 'Accès adhérent activé avec succès',
    'invalid_credentials': 'Identifiants invalides',
    'too_many_attempts': 'Trop de tentatives de connexion. Veuillez réessayer plus tard',
    'notification_sent': 'Notification envoyée avec succès',
    'member_id_mismatch': "Incohérence détectée : la fiche affichée ne correspond pas à l'enregistrement. Veuillez recharger la page avant de sauvegarder.",
};
